import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon, ChevronRightIcon } from 'lucide-react';
import { CtaBand } from '../components/CtaBand';
import { insights } from '../data/insights';
import { formatDate } from '../utils/date';
export function InsightArticle() {
  const {
    slug
  } = useParams();
  const article = insights.find(a => a.slug === slug);
  if (!article) return <Navigate to="/insights" replace data-id="element-422" data-mp="1t16ysns3wbgt" />;
  const related = insights.filter(a => a.slug !== article.slug).slice(0, 2);
  return <>
      <article data-id="element-423" data-mp="1o83yzxwqk5s6">
        <header className="bg-midnight-950 text-champagne-50" data-id="element-424" data-mp="1o8dtnysq7147">
          <div className="mx-auto max-w-3xl px-6 pb-16 pt-12 lg:pb-20 lg:pt-16" data-id="element-425" data-mp="1jbnah2lmjpek">
            <nav aria-label="Breadcrumb" data-id="element-426" data-mp="1ed29h0yjt1p2">
              <ol className="flex flex-wrap items-center gap-1.5 text-xs text-champagne-100/55" data-id="element-427" data-mp="1ea6bxdqm4f15">
                <li data-id="element-428" data-mp="1acigm9l0ck8q">
                  <Link to="/" className="hover:text-champagne-100" data-id="element-429" data-mp="15bky1vw35o6p">Home</Link>
                </li>
                <li aria-hidden="true" data-id="element-430" data-mp="oaj3cd37nb71"><ChevronRightIcon className="h-3.5 w-3.5" data-id="element-431" data-mp="oa0vej76r8ja" /></li>
                <li data-id="element-432" data-mp="t0zf7srduora">
                  <Link to="/insights" className="hover:text-champagne-100" data-id="element-433" data-mp="t1j09icbxt9j">Insights</Link>
                </li>
                <li aria-hidden="true" data-id="element-434" data-mp="fadwq55ucgtx"><ChevronRightIcon className="h-3.5 w-3.5" data-id="element-435" data-mp="faw2bsee87ei" /></li>
                <li aria-current="page" className="text-champagne-300" data-id="element-436" data-mp="jaocuancknmi">{article.category}</li>
              </ol>
            </nav>
            <h1 className="mt-8 font-serif text-4xl leading-tight md:text-6xl" data-id="element-437" data-mp="17222g8u4653s">{article.title}</h1>
            <p className="mt-6 text-sm text-champagne-100/60" data-id="element-438" data-mp="1byk7l9tcw5gn">
              {formatDate(article.date)} · {article.readTime}
            </p>
          </div>
        </header>
        <div className="bg-ivory" data-id="element-439" data-mp="12ynkhcmm7enp">
          <div className="mx-auto max-w-3xl px-6 py-16 lg:py-24" data-id="element-440" data-mp="12xm0ginmfhtu">
            <p className="font-serif text-2xl leading-snug text-midnight-900 md:text-3xl" data-id="element-441" data-mp="3iq1q9h4uktz8">{article.excerpt}</p>
            <div className="mt-10 space-y-6 text-[18px] leading-[1.75] text-midnight-900/80" data-id="element-442" data-mp="3nqfn03100hhy">
              {article.body.map(p => <p key={p.slice(0, 24)} data-id="element-443" data-mp="1tba7ny6pd355">{p}</p>)}
            </div>
            <Link to="/insights" className="mt-14 inline-flex items-center gap-2 text-sm font-medium text-midnight-900 underline decoration-champagne-500 underline-offset-[6px]" data-id="element-444" data-mp="1oamizj5y4ye3">
              <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-445" data-mp="1fgq2ajvjwe62" />
              All insights
            </Link>
          </div>
        </div>
      </article>

      <section className="border-t border-midnight-900/10 bg-champagne-50" data-id="element-446" data-mp="15jlbu7uo9wjg">
        <div className="mx-auto max-w-site px-6 py-16 lg:px-10 lg:py-20" data-id="element-447" data-mp="15locrmxd5a2y">
          <h2 className="font-serif text-3xl text-midnight-900" data-id="element-448" data-mp="10l0m52d1qv99">Further reading</h2>
          <ul className="mt-8 grid gap-x-10 md:grid-cols-2" data-id="element-449" data-mp="wjyjebjx812j">
            {related.map(a => <li key={a.slug} className="border-t border-midnight-900/15" data-id="element-450" data-mp="2uxi4bvj13571">
                <Link to={`/insights/${a.slug}`} className="group block py-6" data-id="element-451" data-mp="2qweo37x2j75a">
                  <p className="text-sm text-midnight-900/55" data-id="element-452" data-mp="cp6qn64s50fp">{a.category} · {a.readTime}</p>
                  <h3 className="mt-2 font-serif text-2xl text-midnight-900 transition-colors duration-150 ease-out group-hover:text-midnight-600" data-id="element-453" data-mp="cnccqbrxe8l4">{a.title}</h3>
                </Link>
              </li>)}
          </ul>
        </div>
      </section>
      <CtaBand data-id="element-454" data-mp="qfa7fhkw41xr" />
    </>;
}